import apiPath from '@store/apiPath'

export default {
  /**
   * 사용자 LMC 잔고조회(벨런스조회)
   * @method GET
   */
  FETCH_BALANCE: `${apiPath.BLOCKCHAIN}/v1/balance`,
}
